import { ColumnSizing } from '../tables-context';
import { MRT_ColumnDef } from 'material-react-table';
import { TableCell } from '../../../components/table/TableCell';
import React from 'react';
import { IFundsReserveConfig } from '../../merchnts/merchant-interfaces';

export enum FundReserveConfigTableAccessorKeys {
	disputeRateStart = 'disputeRateMin',
	reserveRate = 'reserveRate',
	type = 'type',
	reserveType = 'reserveRateType',
	period = 'period',
	createdOn = 'createdOn',
	status = 'disputeRateMax',
	name = 'name'
}

export const defaultFundReserveConfigColumnSizing: ColumnSizing = {
	[FundReserveConfigTableAccessorKeys.name]: 200,
	[FundReserveConfigTableAccessorKeys.disputeRateStart]: 50,
	[FundReserveConfigTableAccessorKeys.reserveRate]: 50,
	[FundReserveConfigTableAccessorKeys.type]: 50,
	[FundReserveConfigTableAccessorKeys.reserveType]: 50,
	[FundReserveConfigTableAccessorKeys.period]: 50,
	// [FundReserveConfigTableAccessorKeys.createdOn]: 50,
};

export const defaultFundReserveConfigInactiveColumnSizing: ColumnSizing = {
	[FundReserveConfigTableAccessorKeys.name]: 170,
	[FundReserveConfigTableAccessorKeys.disputeRateStart]: 50,
	[FundReserveConfigTableAccessorKeys.reserveRate]: 50,
	[FundReserveConfigTableAccessorKeys.type]: 50,
	[FundReserveConfigTableAccessorKeys.period]: 50,
	[FundReserveConfigTableAccessorKeys.createdOn]: 50,
	[FundReserveConfigTableAccessorKeys.status]: 50,
};

export const defaultFundReserveConfigColumns: MRT_ColumnDef<IFundsReserveConfig>[] = [
	{
		accessorKey: FundReserveConfigTableAccessorKeys.name,
		header: 'Name',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Name</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				{renderedCellValue ? renderedCellValue : '-'}
			</TableCell>
		)
	},
	{
		accessorKey: FundReserveConfigTableAccessorKeys.disputeRateStart,
		header: 'Dispute rate',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Dispute rate</span>,
		Cell: ({ renderedCellValue, table, row }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				<div className="fs-7 ms-2 fc-text-overflow fw-bolder">
					{renderedCellValue}% - {row?.original?.disputeRateMax}%
				</div>
			</TableCell>
		)
	},
	{
		accessorKey: FundReserveConfigTableAccessorKeys.reserveRate,
		header: 'Reserve rate',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Reserve rate</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				<div className="fs-7 ms-2 fc-text-overflow">
					{renderedCellValue || renderedCellValue >= 0 ? renderedCellValue / 100 : '-'}
				</div>
			</TableCell>
		)
	},
	{
		accessorKey: FundReserveConfigTableAccessorKeys.type,
		header: 'Reserve rate type',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Reserve rate type</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				<div className="fs-7 ms-2 fc-text-overflow">
					{renderedCellValue === 2 ? '%' : 'FIXED'}
				</div>
			</TableCell>
		)
	},
	{
		accessorKey: FundReserveConfigTableAccessorKeys.period,
		header: 'Reserve hold period',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Reserve hold period</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				<div className="fs-7 ms-2 fc-text-overflow">
					{renderedCellValue ? `${renderedCellValue}d` : '-'}
				</div>
			</TableCell>
		)
	},
	{
		accessorKey: FundReserveConfigTableAccessorKeys.reserveType,
		header: 'Reserve hold type',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Reserve hold type</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				<div className="fs-7 ms-2 fc-text-overflow">
					{renderedCellValue === 1 ? 'FIXED' : 'ROLLING'}
				</div>
			</TableCell>
		)
	},

	// {
	// 	accessorKey: FundReserveConfigTableAccessorKeys.createdOn,
	// 	header: 'Created on',
	// 	enableSorting: false,
	// 	Header: <span className="text-muted fw-bolder main-font-family">Created on</span>,
	// 	Cell: ({ renderedCellValue, table }: any): JSX.Element => (
	// 		<TableCell
	// 			additionalClass="main-font-family"
	// 			density={table?.options?.state?.density}
	// 			isTextOverflow={false}
	// 		>
	// 			{getTableDate(renderedCellValue, true)}
	// 		</TableCell>
	// 	)
	// },
];

export const defaultFundReserveConfigInactiveColumns: MRT_ColumnDef<IFundsReserveConfig>[] = [
	{
		accessorKey: FundReserveConfigTableAccessorKeys.name,
		header: 'Name',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Name</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				{renderedCellValue ? renderedCellValue : '-'}
			</TableCell>
		)
	},
	{
		accessorKey: FundReserveConfigTableAccessorKeys.disputeRateStart,
		header: 'Dispute rate',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Dispute rate</span>,
		Cell: ({ renderedCellValue, table, row }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				<div className="fs-7 ms-2 fc-text-overflow fw-bolder">
					{renderedCellValue}% - {row?.original?.disputeRateMax}%
				</div>
			</TableCell>
		)
	},
	{
		accessorKey: FundReserveConfigTableAccessorKeys.reserveRate,
		header: 'Reserve rate',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Reserve rate</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				<div className="fs-7 ms-2 fc-text-overflow">
					{renderedCellValue || renderedCellValue >= 0 ? renderedCellValue / 100 : '-'}
				</div>
			</TableCell>
		)
	},
	{
		accessorKey: FundReserveConfigTableAccessorKeys.type,
		header: 'Reserve rate type',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Reserve rate type</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				<div className="fs-7 ms-2 fc-text-overflow">
					{renderedCellValue === 2 ? '%' : 'FIXED'}
				</div>
			</TableCell>
		)
	},
	{
		accessorKey: FundReserveConfigTableAccessorKeys.period,
		header: 'Reserve hold period',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Reserve hold period</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				<div className="fs-7 ms-2 fc-text-overflow">
					{renderedCellValue ? `${renderedCellValue}d` : '-'}
				</div>
			</TableCell>
		)
	},
	// {
	// 	accessorKey: FundReserveConfigTableAccessorKeys.createdOn,
	// 	header: 'Created on',
	// 	enableSorting: false,
	// 	Header: <span className="text-muted fw-bolder main-font-family">Created on</span>,
	// 	Cell: ({ renderedCellValue, table }: any): JSX.Element => (
	// 		<TableCell
	// 			additionalClass="main-font-family"
	// 			density={table?.options?.state?.density}
	// 			isTextOverflow={false}
	// 		>
	// 			{getTableDate(renderedCellValue, true)}
	// 		</TableCell>
	// 	)
	// },
	{
		accessorKey: FundReserveConfigTableAccessorKeys.status,
		header: 'Status',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Status</span>,
		Cell: ({ table }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				<div className="fs-7 fc-text-overflow">
					INACTIVE
				</div>
			</TableCell>
		)
	},
];
